export const config = {
    app: {
        name: 'ScanDocFlow'
    },
    server: {
        dev: 'http://localhost:3000/v1/api',
        devV2: 'http://localhost:3001/v2/api',
        prod: 'https://backend.scandocflow.com/v1/api',
        prodV2: 'https://backend.scandocflow.com/v2/api',
    },
    socket: {
        dev: {url: 'http://localhost:3000', path: '/websocket'},
        prod: {url: 'https://backend.scandocflow.com', path: '/websocket'},
    },
    isLocalhost: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
    api() {
        return (
            this.isLocalhost ?
                this.server.dev :
                this.server.prod
        );
    },
    apiV2() {
        return (
            this.isLocalhost ?
                this.server.devV2 :
                this.server.prodV2
        );
    },
    socketApi() {
        if (!this.isLocalhost) {
            return this.socket.prod;
        } else {
            return this.socket.dev;
        }
    },
};
